import { faCheckCircle, faEye, faPencilAlt, faPlusCircle, faTimesCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Dispatch, Fragment, SetStateAction, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import { StoreConnector, StoreProps } from "../../redux/Actions"

const API2 = process.env.REACT_APP_API2

export interface NutritionistListItemInterface {
  id?: number
  full_name: string
  email: string
  description: string
  gender: 'M'|'F',
  address: string
  latitude: string
  longitude: string
  no_ktp: string
  no_npwp: string
  no_rek: string
  phone: string
  img?: string
  photo_ktp?: string
  photo_npwp?: string
  user_id?: number
  bank_id?: number
  link_zoom?: string
}

interface BankListItem {
  id: number
  name: string
}

interface NutritionistFormResponse extends NutritionistListItemInterface {
  password: string
  uploadedPhotoKTP?: File
  uploadedPhotoNPWP?: File
  uploadedImg?: File
}

interface NutritionistFormProps extends StoreProps {
  nutritionist?: NutritionistListItemInterface
  onSubmit: (data: NutritionistFormResponse) => void
  onCancel: () => void
}

function NutritionistFormEl(props: NutritionistFormProps) {
  const { token, nutritionist, onCancel, onSubmit } = props

  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [description, setDesscription] = useState<string>('')
  const [gender, setGender] = useState<string>('M')
  const [address, setAddress] = useState<string>('')
  const [latitude, setLatitude] = useState<string>('')
  const [longitude, setLongitude] = useState<string>('')
  const [noKTP, setNoKTP] = useState<string>('')
  const [noNPWP, setNoNPWP] = useState<string>('')
  const [noRek, setNoRek] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [img, setImg] = useState<string>()
  const [photoKTP, setPhotoKTP] = useState<string>()
  const [photoNPWP, setPhotoNPWP] = useState<string>()
  const [bankId, setBankId] = useState<number>()
  const [linkZoom, setLinkZoom] = useState<string>()

  const [uploadedPhotoKTP, setUploadedPhotoKTP] = useState<File>()
  const [uploadedPhotoNPWP, setUploadedPhotoNPWP] = useState<File>()
  const [uploadedImg, setUploadedImg] = useState<File>()

  const [bankList, setBankList] = useState<Array<BankListItem>>([])

  const [emailValid, setEmailValid] = useState<boolean>(true)

  const uploadHandler = (
    file: FileList,
    previewHandler: Dispatch<SetStateAction<string|undefined>>,
    stateHandler: Dispatch<SetStateAction<File|undefined>>
  ) => {
    if (file[0].size > 1000000) {
      toast('Ukuran file maksimal adalah 1MB', {type: 'error'})
      return
    }

    const reader = new FileReader()

    reader.onload = (ev: ProgressEvent<FileReader>) => {
      const result = ev.target?.result

      if (!result) {
        return
      }

      previewHandler(result.toString())
      stateHandler(file[0])
    }

    reader.readAsDataURL(file[0])
  }

  const submit = () => {
    if (!emailValid && nutritionist === undefined) {
      toast('Email sudah digunakan di akun lain!', {type: 'error'})
      return
    }

    onSubmit({
      full_name: name,
      email: email,
      phone: phone,
      description: description,
      password: password,
      gender: gender === 'M' ? 'M' : 'F',
      address: address,
      latitude: latitude,
      longitude: longitude,
      no_ktp: noKTP,
      no_npwp: noNPWP,
      no_rek: noRek,
      bank_id: bankId,
      uploadedPhotoKTP: uploadedPhotoKTP,
      uploadedPhotoNPWP: uploadedPhotoNPWP,
      uploadedImg: uploadedImg,
      link_zoom: linkZoom
    })
  }

  useEffect(() => {
    if (nutritionist === undefined) {
      return
    }

    setName(nutritionist.full_name)
    setEmail(nutritionist.email)
    setDesscription(nutritionist.description)
    setGender(nutritionist.gender)
    setAddress(nutritionist.address)
    setLatitude(nutritionist.latitude)
    setLongitude(nutritionist.longitude)
    setNoKTP(nutritionist.no_ktp)
    setNoNPWP(nutritionist.no_npwp)
    setNoRek(nutritionist.no_rek)
    setPhone(nutritionist.phone)
    setImg(nutritionist.img)
    setPhotoKTP(nutritionist.photo_ktp)
    setPhotoNPWP(nutritionist.photo_npwp)
    setBankId(nutritionist.bank_id)
    setLinkZoom(nutritionist.link_zoom)
  }, [nutritionist])

  useEffect(() => {
    if (!token) {
      return
    }

    const fetchInitOpt: RequestInit = {
      headers: {
        Authorization: token
      }
    }

    fetch(`${API2}/administration/bank`, fetchInitOpt)
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          toast('Gagal mengambil data!', {type: 'error'})
          return
        }

        setBankList(response)
      })
      .catch(() => toast('Terjadi kesalahan jaringan!', {type: 'error'}))
  }, [token])

  useEffect(() => {
    fetch(`${API2}/check-email?email=${email}`)
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          toast('Gagal memverifikasi email!', {type: 'error'})
          return
        }

        setEmailValid(!response.result.exists)
      })
      .catch(() => toast('Terjadi kegagalan jaringan!', {type: 'error'}))
  }, [email])

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={onCancel}></div>
      <div className="modal-content">
        <div className="box">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <h4 className="title is-size-4">{nutritionist === undefined ? 'Tambah' : 'Ubah'} Nutritionist</h4>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <button className="button is-small is-primary" onClick={submit}>
                  <div className="icon is-small is-left">
                    <FontAwesomeIcon icon={faCheckCircle}/>
                  </div>
                  <span>Simpan</span>
                </button>
                <button className="button is-small is-default ml-1" onClick={onCancel}>
                  <div className="icon is-small is-left">
                    <FontAwesomeIcon icon={faTimesCircle}/>
                  </div>
                  <span>Batal</span>
                </button>
              </div>
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Nama</label>
            <div className="control">
              <input type="text" className="input" value={name} onChange={ev => setName(ev.target.value)}/>
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Email</label>
            <div className="control">
              <input type="email" className="input" value={email} onChange={ev => setEmail(ev.target.value)} />
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Password</label>
            <div className="control">
              <input type="password" className="input" onChange={ev => setPassword(ev.target.value)} />
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Deskripsi</label>
            <div className="control">
              <textarea className="textarea" value={description} onChange={ev => setDesscription(ev.target.value)}/>
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Link Zoom</label>
            <div className="control">
              <input type="text" className="input" value={linkZoom ?? ''} onChange={ev => setLinkZoom(ev.target.value)} />
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Gender</label>
            <div className="select is-fullwidth">
              <select value={gender} onChange={ev => setGender(ev.target.value)}>
                <option value="M">Pria</option>
                <option value="F">Wanita</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label htmlFor="">Alamat</label>
            <div className="control">
              <input type="text" className="input" value={address} onChange={ev => setAddress(ev.target.value)} />
            </div>
          </div>
          <div className="columns mt-0">
            <div className="column">
              <label htmlFor="">Latitude</label>
              <div className="control">
                <input
                  type="number"
                  className="input"
                  value={latitude}
                  onChange={ev => setLatitude(ev.target.value)}
                  step={0.000001}
                />
              </div>
            </div>
            <div className="column">
              <label htmlFor="">Longitude</label>
              <div className="control">
                <input
                  type="number"
                  className="input"
                  value={longitude}
                  onChange={ev => setLongitude(ev.target.value)}
                  step={0.000001}
                />
              </div>
            </div>
          </div>
          <div className="field">
            <label htmlFor="">No. HP</label>
            <div className="control">
              <input type="text" className="input" value={phone} onChange={ev => setPhone(ev.target.value)}/>
            </div>
          </div>
          <div className="columns mt-1">
            <div className="column">
              <div className="field">
                <label htmlFor="">No. Rekening</label>
                <div className="control">
                  <input type="text" className="input" value={noRek} onChange={ev => setNoRek(ev.target.value)} />
                </div>
              </div>
            </div>
            <div className="column">
              <div className="field">
                <label htmlFor="">Bank</label>
                <div className="select is-fullwidth">
                  <select value={bankId} onChange={ev => setBankId(Number(ev.target.value))}>
                    <option value="">Pilih Bank</option>
                    {bankList.map(bank => (
                      <option value={bank.id} key={bank.id}>{bank.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="columns mt-0">
            <div className="column">
              <div className="field">
                <label htmlFor="">No. KTP</label>
                <div className="control">
                  <input type="text" className="input" value={noKTP} onChange={ev => setNoKTP(ev.target.value)} />
                </div>
              </div>
            </div>
            <div className="column">
              <div className="field">
                <label htmlFor="">No. NPWP</label>
                <div className="control">
                  <input type="text" className="input" value={noNPWP} onChange={ev => setNoNPWP(ev.target.value)} />
                </div>
              </div>
            </div>
          </div>
          <div className="columns mt-0">
            <div className="column">
              <div className="field">
                <label htmlFor="">Foto KTP</label>
                <div className="control">
                  <input
                    type="file"
                    className="input"
                    accept="image/*"
                    onChange={ev => ev.target.files !== null && uploadHandler(ev.target.files, setPhotoKTP, setUploadedPhotoKTP)}
                  />
                </div>
              </div>
              {photoKTP && (
                <img src={photoKTP} alt="" className="image mt-1" />
              )}
            </div>
            <div className="column">
              <div className="field">
                <label htmlFor="">Foto NPWP</label>
                <div className="control">
                  <input
                    type="file"
                    className="input"
                    accept="image/*"
                    onChange={ev => ev.target.files !== null && uploadHandler(ev.target.files, setPhotoNPWP, setUploadedPhotoNPWP)}
                  />
                </div>
              </div>
              {photoNPWP && (
                <img src={photoNPWP} alt="" className="image mt-1" />
              )}
            </div>
          </div>
          <div className="columns mt-0">
            <div className="column is-6">
              <div className="field">
                <label htmlFor="">Foto Nutritionist</label>
                <div className="control">
                  <input
                    type="file"
                    className="input"
                    accept="image/*"
                    onChange={ev => ev.target.files !== null && uploadHandler(ev.target.files, setImg, setUploadedImg)}
                  />
                </div>
              </div>
              {img && (
                <img src={img} alt="" className="image mt-1" />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const TrainerForm = StoreConnector(NutritionistFormEl)

function NutritionistList(props: StoreProps) {
  const { token } = props

  const [nutritionistList, setNutritionistList] = useState<Array<NutritionistListItemInterface>>([])
  const [focusedTrainer, setFocusedNutritionist] = useState<number>()
  const [findQuery, setFindQuery] = useState<string>('')
  const [showNutritionistForm, setNutritionistFormVisibility] = useState<boolean>(false)
  const [updateTimestamp, setUpdateTimestamp] = useState<number>(Date.now())
  const [page, setPage] = useState<number>(0)
  const limit = 20

  const nutritionistForm = (id?: number) => {
    setFocusedNutritionist(id)
    setNutritionistFormVisibility(true)
  }

  const submitNutritionist = (nutritionist: NutritionistFormResponse) => {
    if (!token) {
      return
    }

    const {
      full_name: name,
      email,
      password,
      address,
      latitude,
      longitude,
      description,
      gender,
      no_ktp,
      no_npwp,
      no_rek,
      bank_id,
      phone,
      uploadedPhotoKTP,
      uploadedImg,
      uploadedPhotoNPWP,
      link_zoom
    } = nutritionist

    const form = uploadedPhotoKTP || uploadedImg || uploadedPhotoNPWP ? new FormData() : new URLSearchParams()

    if (focusedTrainer !== undefined) {
      form.append('id', String(focusedTrainer))
    }

    form.append('name', name)
    form.append('email', email)
    form.append('password', password)
    form.append('address', address)
    form.append('latitude', latitude)
    form.append('longitude', longitude)
    form.append('description', description)
    form.append('gender', gender)
    form.append('no_ktp', no_ktp)
    form.append('no_npwp', no_npwp)
    form.append('no_rek', no_rek)
    form.append('bank_id', String(bank_id))
    form.append('phone', phone)

    if (link_zoom) {
      form.append('link_zoom', link_zoom)
    }

    if (uploadedImg) {
      // @ts-ignore
      form.append('img', uploadedImg)
    }

    if (uploadedPhotoKTP) {
      // @ts-ignore
      form.append('photo_ktp', uploadedPhotoKTP)
    }

    if (uploadedPhotoNPWP) {
      // @ts-ignore
      form.append('photo_npwp', uploadedPhotoNPWP)
    }

    const fetchInitOpt: RequestInit = {
      method: 'POST',
      headers: {
        Authorization: token
      },
      body: form
    }

    fetch(`${API2}/administration/nutritionist`, fetchInitOpt)
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          toast('Gagal menyimpand data!', {type: 'error'})
          return
        }

        toast('Data berhasil disimpan!', {type: 'success'})
        setNutritionistFormVisibility(false)
        setUpdateTimestamp(Date.now())
      })
      .catch(() => toast('Terjadi kegagalan jaringan!', {type: 'error'}))
  }

  const removeNutritionist = (id?: number) => {
    if (!window.confirm('Anda yakin menghapus data ini?') || !token) {
      return
    }

    const fetchInitOpt: RequestInit = {
      method: 'DELETE',
      headers: {
        Authorization: token
      }
    }

    fetch(`${API2}/administration/nutritionist/${id}`, fetchInitOpt)
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          toast('Gagal menghapus data!', {type: 'error'})
          return
        }

        toast('Berhasil menghapus data!', {type: 'success'})
        setUpdateTimestamp(Date.now())
      })
      .catch(() => toast('Kegagalan jaringan!', {type: 'error'}))
  }

  useEffect(() => {
    if (!token) {
      return
    }

    const fetchInitOpt: RequestInit = {
      headers: {
        Authorization: token
      }
    }

    fetch(`${API2}/administration/nutritionist`, fetchInitOpt)
      .then(response => response.json())
      .then(response => {
        if (response.error) {
          toast('Gagal mengambil data!', {type: 'error'})
          return
        }

        setNutritionistList(response)
      })
      .catch(() => toast('Terjadi kegagalan jaringan!', {type: 'error'}))
  }, [token, updateTimestamp])

  useEffect(() => {
    setPage(0)
  }, [findQuery])

  return (
    <Fragment>
      <div className="mt-3">
        <div className="box">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <h4 className="title is-size-4">Daftar Nutritionist</h4>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <input type="text" className="input is-small mr-1" value={findQuery} onChange={ev => setFindQuery(ev.target.value)} placeholder="Cari" />
                <button className="button is-small is-primary" onClick={() => nutritionistForm()}>
                  <div className="icon is-small is-left">
                    <FontAwesomeIcon icon={faPlusCircle}/>
                  </div>
                  <span>Tambah Nutritionist</span>
                </button>
              </div>
            </div>
          </div>
          <div style={{overflowX: 'auto'}}>
            <table className="table is-bordered is-fullwidth" style={{whiteSpace: 'nowrap'}}>
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Email</th>
                  <th>No. HP</th>
                  <th>Gender</th>
                  <th style={{width: 170}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {nutritionistList
                  .slice(page * limit, (page + 1) * limit)
                  .filter(nutritionist => nutritionist.email.match(new RegExp(findQuery, 'ig')) || nutritionist.full_name.match(new RegExp(findQuery, 'ig')))
                  .map(nutritionist => (
                    <tr key={nutritionist.id}>
                      <td>{nutritionist.full_name}</td>
                      <td>{nutritionist.email}</td>
                      <td>{nutritionist.phone}</td>
                      <td>{nutritionist.gender === 'F' ? 'Wanita' : 'Pria'}</td>
                      <td>
                        <Link to={`/admin/do-monitor/nutritionist/${nutritionist.user_id}?token=${token}`} className="button is-small is-primary" target="_blank">
                          <div className="icon is-small is-left">
                            <FontAwesomeIcon icon={faEye}/>
                          </div>
                          <span>Monitor</span>
                        </Link>
                        <button className="button is-small is-primary ml-1" onClick={() => nutritionistForm(nutritionist.id)}>
                          <div className="icon is-small is-left">
                            <FontAwesomeIcon icon={faPencilAlt}/>
                          </div>
                          <span>Ubah</span>
                        </button>
                        <button className="button is-small is-danger ml-1" onClick={() => removeNutritionist(nutritionist.id)}>
                          <div className="icon is-small is-left">
                            <FontAwesomeIcon icon={faTrashAlt}/>
                          </div>
                          <span>Hapus</span>
                        </button>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
            {nutritionistList.length > limit && (
              <div className="field has-addons">
                <p className="control">
                  <button className="button is-small" onClick={() => page > 0 && setPage(page - 1)}>
                    &lt;&lt;
                  </button>
                </p>
                {Object.keys(Array(Math.ceil(nutritionistList.filter(nutritionist => nutritionist.email.match(new RegExp(findQuery, 'ig')) || nutritionist.full_name.match(new RegExp(findQuery, 'ig'))).length / limit)).fill(undefined)).map(key => (
                  <p className="control" key={key}>
                    <button className={`button is-small ${page === Number(key) ? 'is-primary' : 'is-default'}`} onClick={() => setPage(Number(key))}>
                      {Number(key) + 1}
                    </button>
                  </p>
                ))}
                <p className="control">
                  <button className="button is-small" onClick={() => page < Math.ceil(nutritionistList.filter(nutritionist => nutritionist.email.match(new RegExp(findQuery, 'ig')) || nutritionist.full_name.match(new RegExp(findQuery, 'ig'))).length / limit) - 1 && setPage(page + 1)}>
                    &gt;&gt;
                  </button>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {showNutritionistForm && (
        <TrainerForm
          nutritionist={nutritionistList.find(trainer => trainer.id === focusedTrainer)}
          onSubmit={submitNutritionist}
          onCancel={() => setNutritionistFormVisibility(false)}
        />
      )}
    </Fragment>
  )
}

export default StoreConnector(NutritionistList)